export default __webpack_public_path__ + "static/media/logo-dailycious-white.9dbdbd3c.svg";